import React from 'react';
import {Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import {useTranslation} from 'react-i18next';
import NewContractFormComponent, {isContractFormValid} from '../../Generic/NewContractFormComponent';
import type {Contract} from '../../../types/contract';

interface EditContractDialogProps {
    open: boolean;
    contract: Contract;
    branchName?: string;
    submitting?: boolean;
    onClose: () => void;
    onSubmit: () => void;
    handleContractFormChange: (field: keyof Contract) => (event: any) => void;
    contractSubmitError?: { message: string; violations: string[] } | null;
}

const EditContractDialog: React.FC<EditContractDialogProps> = ({
                                                                     open,
                                                                     contract,
                                                                     branchName,
                                                                     submitting = false,
                                                                     onClose,
                                                                     onSubmit,
                                                                     handleContractFormChange,
                                                                     contractSubmitError,
                                                                 }) => {
    const {t} = useTranslation();
    const [showAllErrors, setShowAllErrors] = React.useState(false);

    const handleSave = () => {
        if (!isContractFormValid(contract)) {
            setShowAllErrors(true);
            return;
        }
        setShowAllErrors(false);
        onSubmit();
    };

    const handleClose = () => {
        setShowAllErrors(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={() => {
        }} disableEscapeKeyDown maxWidth={false} PaperProps={{sx: {width: {xs: 'calc(100% - 32px)', sm: '600px'}, margin: 'auto'}}}>
            <DialogTitle>{t('contracts.dialog.editTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 2}}>
                    <NewContractFormComponent
                        newContract={contract}
                        branchName={branchName}
                        handleContractFormChange={handleContractFormChange}
                        showAllErrors={showAllErrors}
                        backendError={contractSubmitError}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={submitting}>
                    {t('common.actions.cancel')}
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    disabled={submitting}
                    startIcon={submitting ? <CircularProgress size={16} color="inherit"/> : <SaveIcon/>}
                >
                    {t('common.actions.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditContractDialog;
